import { createFileRoute } from '@tanstack/react-router';

import { ProjectCreationPage } from '@/areas/projects/ProjectCreation/ProjectCreationPage';
import { canCreateProject } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/next/projects/create')({
    staticData: { access: { permissions: canCreateProject }, chrome: 'none' } satisfies PageStaticData,
    component: RouteComponent,
});

/* A static segment, so the router ranks it above `$projectId` and never reads "create" as a project id. */
function RouteComponent(): JSX.Element {
    return <ProjectCreationPage />;
}
